module.exports = __webpack_public_path__ + "img/wechat.7479228c.png";